import React from 'react'
import PropTypes from 'prop-types'
// import R from 'ramda'

import BaseNumberField from './baseNumber'

const MachineCountField = ({
  name,
  width,
  onChange,
  machineCount,
  readOnly
}) => (
  <BaseNumberField
    width={width}
    readOnly={ readOnly }
    labelTxt='Machine Count'
    popupTxt='How many machines can be used under this license. The last one will always have a short 1 hour session.'
    min={1}
    name={name}
    value={machineCount}
    onChange={onChange}
  />
)

MachineCountField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  machineCount: PropTypes.number.isRequired,
  readOnly: PropTypes.bool
}
export default MachineCountField



// WEBPACK FOOTER //
// ./webAdmin/forms/machineCountField.js